import script from "./roadmapDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./roadmapDetail.vue?vue&type=script&setup=true&lang=js"

import "./roadmapDetail.vue?vue&type=style&index=0&id=415789ea&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415789ea"]])

export default __exports__